
import { defineComponent, PropType, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import Slider from 'primevue/slider';
import type { ScrollPageData } from './index';

export default defineComponent({
  name: 'ScrollPageForm',

  components: {
    Button,
    Slider,
  },

  props: {
    modelValue: {
      type: Object as PropType<ScrollPageData>,
      default: () => ({ percent_scroll: 10 }),
    },
    formValidation: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['update:modelValue', 'cancel', 'close', 'submit'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const localData = ref<ScrollPageData>({ ...props.modelValue });

    watch(localData, (newData) => {
      emit('update:modelValue', newData);
    }, { deep: true });

    watch(() => props.modelValue, (newValue) => {
      if (newValue !== localData.value) {
        localData.value = { ...newValue };
      }
    });

    return {
      t,
      localData,
    };
  },
});
